import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeModificationEnum } from 'src/app/constantes/type-modification.enum';
import { CybermetrieEnum } from '../../constantes/cybermetrie.enum';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { ContexteModificationEnum } from 'src/app/constantes/contexte-modification.enum';
import { SystemeEntiteEnum } from 'src/app/constantes/systeme-entite.enum';

@Component({
  selector: 'app-page-confirmation-courriel',
  templateUrl: './page-confirmation-courriel.component.html',
  standalone: false,
})
export class PageConfirmationCourrielComponent implements OnInit {
  isAjout = false;

  private readonly router = inject(Router);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);

  ngOnInit(): void {
    const navigationState = this.router.lastSuccessfulNavigation?.extras.state as {
      typeModification: TypeModificationEnum;
    };
    this.isAjout = navigationState?.typeModification === TypeModificationEnum.AJOUT;
  }

  onSystemesEnErreurChange(systemesEnErreur: SystemeEntiteEnum[]): void {
    this.envoyerCybermetrie(systemesEnErreur.length > 0);
  }

  envoyerCybermetrie(succesPartiel: boolean): void {
    this.cybermetrieCoordonneesService.transactionComplete(
      this.isAjout
        ? CybermetrieEnum.LABEL_MODIFIER_COURRIEL_AJOUT
        : CybermetrieEnum.LABEL_MODIFIER_COURRIEL,
      ContexteModificationEnum.COURRIEL,
      succesPartiel
        ? CybermetrieEnum.EXTRA_ATTRIBUT_PARTIEL_APPEL_REQUIS
        : CybermetrieEnum.EXTRA_ATTRIBUT_APPEL_REQUIS,
    );
  }
}
